import React from "react";

const DataTransjakarta = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Transjakarta"
        src="https://lookerstudio.google.com/embed/reporting/405f0f6c-81e6-4118-b872-9f70b31bd1d8/page/1M"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataTransjakarta;
